/**
 * User: herbert
 * Date: 10.05.16
 * Time: 12:45
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';

import steleActions from '../../actions/stele-actions.js';

import * as config from '../../../../config.js';
import T from '../../../../nls/translate.js';


export default React.createClass({
	propTypes: {
		type: React.PropTypes.number.isRequired,
		parentIdx: React.PropTypes.number.isRequired,
	},
	_onBosch: function() {
		steleActions.setType(config.C_BOSCH, this.props.parentIdx);
	},
	_onAxis: function() {
		steleActions.setType(config.C_AXIS, this.props.parentIdx);
	},
	_onEneo: function() {
		steleActions.setType(config.C_ENEO, this.props.parentIdx);
	},
	render: function () {
		return (
				<div>
					<span>{T.current.SUMMARY.CAM}</span><br />
					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.type === config.C_BOSCH ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onBosch} >
							<span>{T.current.SUMMARY.C_BOSCH}</span>
							{/* <img src="img/stele/parameters/Icon_rund_black_4.png"  className="slx-stele-summary__option-img48" /> */}
						</div>
						<div className={this.props.type === config.C_AXIS ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onAxis} >
							<span>{T.current.SUMMARY.C_AXIS}</span>
							{/* <img src="img/stele/parameters/Icon_rund_black_4.png"  className="slx-stele-summary__option-img48" /> */}
						</div>
						<div className={this.props.type === config.C_ENEO ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onEneo} >
							<span>{T.current.SUMMARY.C_ENEO}</span>
							{/* <img src="img/stele/parameters/Icon_rund_black_4.png"  className="slx-stele-summary__option-img48" /> */}
						</div>
					</div>
				</div>
		);
	}
});
